module.exports = __webpack_public_path__ + "media/images/contact/WS-julien-1eebae24252b5c0812080e4740225d0c.jpg";